import React, { useState, useEffect } from "react";
import { observer } from "mobx-react-lite";
import "react-datepicker/dist/react-datepicker.css";
import { globalVars } from "../../global/GlobalVars.js";
import * as language from "../../utils/language.js";
import * as render from "../../utils/render.js";

const DataPicker = observer((props) => {
  // =======================================================================
  // Statusvariablen
  const currentId = props.selectedCounters[props.index]?.id;

  const [selectedId, setSelectedId] = useState(currentId);

  useEffect(() => {
    if (currentId !== selectedId) {
      setSelectedId(currentId);
    }
  }, [currentId]);

  // =======================================================================
  // Funktion, die aufgerufen wird, wenn eine Option im Dropdown ausgewählt wird
  const handleSelect = (event) => {
    const value = event.target.value;
    setSelectedId(value);
    let newselectedCounters = [...props.selectedCounters];
    newselectedCounters[props.index].id = value;
    props.setselectedCounters(newselectedCounters);
  };

  // Festlegen des Indexes für die gewählte Sprache
  let sortLanguageIndex;
  if (globalVars.language === "de") {
    sortLanguageIndex = 0;
  } else if (globalVars.language === "it") {
    sortLanguageIndex = 1;
  } else if (globalVars.language === "en") {
    sortLanguageIndex = 2;
  } else {
    sortLanguageIndex = 0; // Fallback
  }

  // Sortieren der Daten nach dem Namen in der gewählten Sprache
  let sortedData = props.allCounters.sort((a, b) =>
    a.name[sortLanguageIndex].localeCompare(b.name[sortLanguageIndex]),
  );

  // =======================================================================
  // Elemente skaliert anzeigen
  const scaleSelectWidth = 0.74626865671641791044776119402985;

  // =======================================================================
  // Auswahl Datenpunkte rendern
  return (
    <div
      style={{
        position: "absolute",
        top: props.style.top,
        left: props.style.left,
        display: "flex",
        alignItems: "center",
      }}
    >
      <select
        style={{
          background: "#0f1117",
          border: "1px solid #2a3448",
          borderRadius: render.parseCssValue("6px", globalVars.scaleFactor),
          color: "#cbd5e1",
          height: props.style.height,
          width: `${parseFloat(props.style.width) * scaleSelectWidth}px`,
          fontSize: props.style.fontSize,
              outline: "none",
              cursor: "pointer",
        }}
        onChange={handleSelect}
        value={selectedId}
      >
        <option value=""></option> {/* Leere Option hinzugefügt */}
        {sortedData.map((item) => (
          <option key={item.id} value={item.id}>
            {language.displayText(item.name)}
          </option>
        ))}
      </select>
    </div>
  );
});

export default DataPicker;
